import React from 'react'
import './footer.css'

function Footer() {
  return (
    <>
    <div className="footer">
      <div className="copyright">
      Copyright@weather.com
      </div>
      <div className="email">
        Contact Us - <strong>Email</strong> : abhi201002.ag@gmail.com and <strong>Phone no.</strong> 7468293724
      </div>
    </div>
    </>
  )
}

export default Footer